import React from 'react';
import './HashGallery.css';

const HashGallery = () => {
    return (
        <div className="hash-gallery-hero">
            <div className="video-background">
                <video 
                    autoPlay 
                    loop 
                    muted 
                    playsInline
                    className="fullscreen-video"
                >
                    <source src="/img/clip3.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div className="video-overlay">
                    <div className="hero-content">
                        <h1 className="hero-title">
                            <span>Hash Gallery</span>
                            <span className="launch-badge">BETA LIVE!</span>
                        </h1>
                        <p className="hero-description">
                            Experience the future of digital art spaces. Immersive environments where art comes to life with proper spacing, context, and revolutionary presentation.
                        </p>
                        <div className="hero-cta-container">
                            <a href="https://immuta.art/hash-gallery" target="_blank" rel="noopener noreferrer" className="hero-cta-button">Build My Gallery</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HashGallery;
